import { render } from "./ProblemCard.vue?vue&type=template&id=67943110&scoped=true"
import script from "./ProblemCard.vue?vue&type=script&lang=js"
export * from "./ProblemCard.vue?vue&type=script&lang=js"

import "./ProblemCard.vue?vue&type=style&index=0&id=67943110&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67943110"]])

export default __exports__